import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import { queryKeys, RESTAURANT_SELECT, SSR_STALE_TIME } from "@/lib/queryKeys";

export const useFeaturedRestaurants = () => {
  return useQuery({
    queryKey: queryKeys.featuredRestaurants,
    staleTime: SSR_STALE_TIME,
    queryFn: async () => {
      console.log('Fetching featured restaurants...');
      const { data, error } = await supabase
        .from('restaurants')
        .select(RESTAURANT_SELECT)
        .eq('is_featured', true)
        .eq('approval_status', 'approved')
        .gt('featured_until', new Date().toISOString())
        .order('updated_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching featured restaurants:', error);
        throw error;
      }
      
      console.log('Featured restaurants:', data);
      return data as RestaurantWithEventSpaces[];
    },
  });
};
